import React from "react";

export default function MenuIcon({ size = 24, color = "#002f34" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="4" width="24" height="2" fill={color} />
      <rect y="11" width="24" height="2" fill={color} />
      <rect y="18" width="24" height="2" fill={color} />
    </svg>
  );
}
